import React from 'react';
import { Grid, List, ListItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { museoSansFont300 } from 'util/EnumHelper';
import { localize } from 'util/Localizer';

/* eslint-disable max-len */
const startingText = [
    `We’re making it easier to access route information! While you’ll still receive daily route emails for now, you can also find all route details directly in the Onboarding Report within the District Portal.`
];

const items = [
    `Effective dates and days for the route`,
    `Pickup and drop-off addresses and times`,
    `Passenger information`,
    `Driver and vehicle information (when assigned)`,
    `Price breakdown`
];
/* eslint-enable max-len */

const ImageContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'center'
}));

const Image = styled('img')(() => ({
    width: '80%',
    WebkitBoxShadow: '1px 1px 3px 0px rgba(211,211,211,1)',
    MozBoxShadow: '1px 1px 3px 0px rgba(211,211,211,1)',
    boxShadow: '1px 1px 3px 0px rgba(211,211,211,1)',
    borderRadius: '25px'
}));

function HowToViewRouteDetail() {
    return (
        <Grid container spacing={2}>
            <Grid container sx={{
                fontFamily: museoSansFont300,
                fontSize: 16
            }}>
                <Grid item xs={12} md={7}>
                    <List>
                        {startingText.map(text => (
                            <ListItem key={text}>{text}</ListItem>
                        ))}
                    </List>
                    {/* eslint-disable max-len */ }
                    <ul>
                        <li>Look for the <b>document icon</b> at the top right corner of the card to confirm that Route Details are available.</li>
                        <li><b>Click the top of the card</b> to expand and view trip information.</li>
                        <li>PDFs of Route Details for each trip can be viewed and downloaded by clicking <b>View Route Details</b>.</li>
                        <li>If no icon or address link is visible, the Route Details for that trip are not yet available—please check back later.</li>
                    </ul>
                    <List>
                        <ListItem><b>Route Details include:</b></ListItem>
                    </List>
                    <ul>
                        {items.map((item) => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>
                    <List>
                        <ListItem>This feature gives you quick, centralized access to route details while maintaining the convenience of email notifications.</ListItem>
                    </List>
                    {/* eslint-enable max-len */ }
                </Grid>
                <Grid item xs={12} md={5} sx={{ mt: '24px' }}>
                    <ImageContainer>
                        <Image
                            src="/img/Route-detail-sample.png"
                            alt={localize('howtoviewroutedetail.imgAltText')}
                        />
                    </ImageContainer>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default HowToViewRouteDetail;